module.exports = __webpack_public_path__ + "img/profile.4b6b9e43.svg";